import json from "../json/salesforceSupportRepresentatives.json";

export default async () => JSON.parse(JSON.stringify(await json));
